import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { productsApi, suppliersApi } from '../services/api';

function fmt(n) {
  return new Intl.NumberFormat('cs-CZ', { style: 'currency', currency: 'CZK', maximumFractionDigits: 0 }).format(n || 0);
}

export default function Products() {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [suppliers, setSuppliers] = useState([]);
  const [form, setForm] = useState({ name: '', description: '', price_buy: '', price_sell: '', stock_quantity: 0, min_stock: 0, category: '', supplier_id: '', is_presale: false });
  const [saving, setSaving] = useState(false);
  const [imageFile, setImageFile] = useState(null);

  function load() {
    setLoading(true);
    productsApi.list({ search, limit: 100 }).then(r => { setProducts(r.data); setTotal(r.total); }).finally(() => setLoading(false));
  }
  useEffect(() => { load(); }, [search]);
  useEffect(() => { suppliersApi.list().then(setSuppliers); }, []);

  async function save(e) {
    e.preventDefault();
    setSaving(true);
    try {
      const fd = new FormData();
      Object.entries(form).forEach(([k, v]) => fd.append(k, v));
      if (imageFile) fd.append('images', imageFile);
      const result = await productsApi.create(fd);
      setShowModal(false);
      navigate(`/products/${result.id}`);
    } finally {
      setSaving(false);
    }
  }

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">Produkty</h1>
        <button className="btn btn-primary" onClick={() => setShowModal(true)}>+ Nový produkt</button>
      </div>

      <div className="card" style={{ marginBottom: 16, padding: '12px 16px' }}>
        <div className="filters">
          <input className="form-control" style={{ width: 260 }} placeholder="Hledat produkt..." value={search} onChange={e => setSearch(e.target.value)} />
          <span style={{ fontSize: 13, color: 'var(--text-muted)' }}>Celkem: {total}</span>
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: 14 }}>
        {products.map(p => (
          <Link key={p.id} to={`/products/${p.id}`} style={{ textDecoration: 'none' }}>
            <div className="card" style={{ cursor: 'pointer', overflow: 'hidden', padding: 0 }}>
              <div style={{ height: 140, background: '#f5f5f0', overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                {p.image_url ? (
                  <img src={p.image_url} alt={p.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                ) : (
                  <span style={{ fontSize: 48 }}>📦</span>
                )}
              </div>
              <div style={{ padding: '12px 14px' }}>
                <div style={{ fontWeight: 600, fontSize: 14, marginBottom: 4, lineHeight: 1.3 }}>{p.name}</div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 6 }}>
                  <span style={{ fontSize: 16, fontWeight: 700, color: 'var(--blue)' }}>{fmt(p.price_sell)}</span>
                  <span style={{
                    fontSize: 11, padding: '2px 7px', borderRadius: 10,
                    background: p.stock_quantity <= p.min_stock ? 'var(--red-light)' : 'var(--green-light)',
                    color: p.stock_quantity <= p.min_stock ? 'var(--red)' : 'var(--green)',
                    fontWeight: 600,
                  }}>
                    {p.is_presale ? '⏳ Předprodej' : `${p.stock_quantity} ks`}
                  </span>
                </div>
                <div style={{ marginTop: 8 }}>
                  <button
                    onClick={async e => { e.preventDefault(); await productsApi.toggleShop(p.id, !p.shop_visible); load(); }}
                    style={{ fontSize: 11, padding: '3px 9px', borderRadius: 10, border: 'none', cursor: 'pointer', fontWeight: 600,
                      background: p.shop_visible ? '#d4edda' : '#f0f0f0',
                      color: p.shop_visible ? '#1a7a3e' : '#888' }}>
                    {p.shop_visible ? '🛒 V eshopu' : '+ Přidat do eshopu'}
                  </button>
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>

      {loading && <div className="loading-center"><div className="spinner" /></div>}
      {!loading && products.length === 0 && <div className="empty-state">Žádné produkty</div>}

      {/* New product modal */}
      {showModal && (
        <div className="modal-overlay" onClick={e => e.target === e.currentTarget && setShowModal(false)}>
          <div className="modal">
            <div className="modal-header">
              <div className="modal-title">Nový produkt</div>
              <button className="btn btn-secondary btn-sm" onClick={() => setShowModal(false)}>✕</button>
            </div>
            <form onSubmit={save}>
              <div className="modal-body">
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                  {[['name','Název *',true],['category','Kategorie',false]].map(([f,l,req]) => (
                    <div className="form-group" key={f} style={f==='name'?{gridColumn:'1/-1'}:{}}>
                      <label className="form-label">{l}</label>
                      <input className="form-control" value={form[f]} onChange={e => setForm(p=>({...p,[f]:e.target.value}))} required={req} />
                    </div>
                  ))}
                  <div className="form-group">
                    <label className="form-label">Nákupní cena (Kč)</label>
                    <input className="form-control" type="number" step="0.01" value={form.price_buy} onChange={e => setForm(p=>({...p,price_buy:e.target.value}))} />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Prodejní cena (Kč) *</label>
                    <input className="form-control" type="number" step="0.01" value={form.price_sell} onChange={e => setForm(p=>({...p,price_sell:e.target.value}))} required />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Počet na skladě</label>
                    <input className="form-control" type="number" value={form.stock_quantity} onChange={e => setForm(p=>({...p,stock_quantity:e.target.value}))} />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Min. sklad</label>
                    <input className="form-control" type="number" value={form.min_stock} onChange={e => setForm(p=>({...p,min_stock:e.target.value}))} />
                  </div>
                  <div className="form-group" style={{ gridColumn: '1/-1' }}>
                    <label className="form-label">Dodavatel</label>
                    <select className="form-control" value={form.supplier_id} onChange={e => setForm(p=>({...p,supplier_id:e.target.value}))}>
                      <option value="">— bez dodavatele —</option>
                      {suppliers.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
                    </select>
                  </div>
                  <div className="form-group" style={{ gridColumn: '1/-1' }}>
                    <label className="form-label">Popis</label>
                    <textarea className="form-control" value={form.description} onChange={e => setForm(p=>({...p,description:e.target.value}))} rows={3} />
                  </div>
                  <div className="form-group" style={{ gridColumn: '1/-1' }}>
                    <label className="form-label">Fotka</label>
                    <input type="file" accept="image/*" onChange={e => setImageFile(e.target.files[0])} />
                  </div>
                  <div className="form-group" style={{ gridColumn: '1/-1' }}>
                    <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer' }}>
                      <input type="checkbox" checked={form.is_presale} onChange={e => setForm(p=>({...p,is_presale:e.target.checked}))} />
                      <span>Předprodej (zboží ještě nedorazilo)</span>
                    </label>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>Zrušit</button>
                <button type="submit" className="btn btn-primary" disabled={saving}>{saving ? 'Ukládám...' : 'Vytvořit produkt'}</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
